export const configKeys = {
  /**
   * Config key for translation download uri
   * @type {string}
   */
  TRANSLATION_LOCALES_DOWNLOAD_URI: 'translation.locales.download.uri'
};
